export const SurveyEvents = {
  Shown: "survey_shown",
  Started: "survey_started",
  QuestionAnswered: "survey_question_answered",
  Completed: "survey_completed",
  Dismissed: "survey_dismissed",
  ChooseNewCoachClicked: "survey_choose_new_coach_clicked",
  BookAnotherSessionClicked: "survey_book_another_session_clicked",
} as const;
